import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=6b277afa"
import script from "./InfoTooltip.vue?vue&type=script&lang=ts"
export * from "./InfoTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports